<template>
  <section ref="targetElement">
    <div v-if="lists && lists.length > 0" class="list list-default news-list">
      <div
        v-for="(item, key) in lists"
        :key="key"
        ref="list"
        class="list-box"
      >
        <!-- TODO: 링크 다시 고민 -->
        <a href="#" @click.prevent="linkTo(item)">
          <template v-if="type === 'report'">
            <div class="list-thumb">
              <img :src="item[`${type}ImagePath`] || require('@/static/image/thumbnail.png')" alt="" @error.once="onImageError">
            </div>
          </template>
          <template v-else>
            <div v-if="item[`${type}ImagePath`]" class="list-thumb">
              <img :src="item[`${type}ImagePath`]" alt="" @error.once="onImageError">
            </div>
          </template>
          <div class="list-cont">
            <p class="list-title">
              <html-view :value="item[`${type}Title`] | highlight(keyword)" />
            </p>
            <html-view
              v-if="(item[`${type}SubTitle`]&& item[`${type}SubTitle`].trim().length > 0) || (item[`${type}Summary`] && item[`${type}Summary`].trim().length > 0)"
              class="list-desc"
              tag="p"
              :value="(item[`${type}SubTitle`] || item[`${type}Summary`]) | highlight(keyword)"
            />
            <div>
              <span v-if="item[`${type}Source`]" class="list-category">{{ item[`${type}Source`] }}</span>
              <time class="list-date">{{ item[`${type}${date}`] | dateFormat }}</time>
            </div>
          </div>
        </a>
      </div>
    </div>

    <loading v-if="loading" />

    <pagination
      v-if="pagination.total"
      :data="pagination"
      :more-activation="moreActivation"
      :is-mobile="isMobile"
      :page-query="pageQuery"
      :minimum-size="size"
      @movePage="movePageNews"
      @more="more"
    />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import newsroomApi from '@/api/newsroom'
import { capitalize } from '@/util'
import list from '@/mixins/list'
import observeSize from '@/mixins/observeSize'

export default {
  name: 'NewsroomList',
  components: {
    pagination: () => import('@/components/base/Pagination'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [list, observeSize],
  props: {
    type: {
      type: String,
      default: 'report'
    },
    date: {
      type: String,
      default: 'createDate'
    },
    pageQuery: {
      type: String,
      default: 'page'
    },
    query: {
      type: Object,
      default: () => {}
    },
    size: {
      type: Number,
      default: 20
    },
    keyword: {
      type: String,
      default: ''
    },
    prevRoute: {
      type: String || null || undefined,
      default: null
    }
  },
  data () {
    return {
      defaultImgPath: require('@/static/image/default.jpg'),
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      topPosition: 'positionTop/GET_POSITION_TOP',
      savePage: 'positionTop/GET_SAVE_PATE'
    }),
    capitalizeType () {
      return capitalize(this.type)
    }
  },
  watch: {
    '$route.query' (query, fromQuery) {
      this.$emit('prevRouteUpdate', fromQuery.current)

      if (fromQuery.word !== query.word) {
          this.getApi({
            pageNumber: 1,
            searchKeyword: query.word
          })
        return
      }

      if (!query[this.pageQuery] || this.isMobile) {
        return
      }
      this.getApi({
        pageNumber: query[this.pageQuery],
      })
    },
    '$route.params.locale' () {
      if (this.$route.query[this.pageQuery] !== '1') {
        this.pagination.current = 1
        this.$router.push({
          query: {
            [this.pageQuery]: 1
          }
        }).catch(e => {})
      }
      // this.listParams.pageNumber = 1
      this.getApi({ pageNumber: 1 })
    },
    pagination (v) {
      this.$emit('countChang', { type: this.type, size: v.total })
    },
    isMobile (v) {
      if (!v) {
        this.lists = this.desserts
      } else {
        if (this.$route.query[this.pageQuery]) {
          this.getApiMobile(this.$route.query[this.pageQuery])
        }
      }
    },
  },
  beforeMount () {
    // if (!this.$route.query.page) {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       page: 1
    //     }
    //   })
    // }
    this.listParams.pageNumber = this.$route.query[this.pageQuery] || 1
    this.listParams.pageSize = this.size
    // this.listParams.pageSize = 2
  },
  mounted () {
    if (this.isMobile) {
      this.getApiMobile(this.listParams.pageNumber)
    } else {
      this.getApi({ pageNumber: this.listParams.pageNumber })
    }
  },
  methods: {
    ...mapActions({
      positionTopChange: 'positionTop/positionTopChange'
    }),
    async getApiMobile (pageNumber) {
      this.loading = true
      let options = {
        pageNumber: 1,
        pageSize: Number(pageNumber) * this.listParams.pageSize
      }
      if (this.keyword) {
        options = {
          ...options,
          searchKeyword: this.keyword,
          searchType: 'TITLE_CONTENT'
        }
      }
      this.getListMobile(newsroomApi[`get${this.capitalizeType}`], options, this.pageQuery).then(() => {
        this.loading = false
        this.$emit('loaded:newsroom', this.lists)
        this.moveScrollTop()
      })
    },
    getApi (pageNumber) {
      this.loading = true
      let options = {}
      if (this.keyword) {
        options = {
          ...options,
          searchKeyword: this.keyword,
          searchType: 'TITLE_CONTENT'
        }
      }
      const params = Object.assign({}, options, pageNumber)
      this.getList(newsroomApi[`get${this.capitalizeType}`], params).then(() => {
        this.lists = this.desserts
        this.loading = false
        this.$emit('loaded:newsroom', this.lists)
      }).then(() => {
        this.moveScrollTop()
      })
    },
    moveScrollTop () {
      if (this.savePage.indexOf(this.prevRoute) !== -1) {
        window.scrollTo(0, this.topPosition)
      }
    },
    linkTo (item) {
      if (this.type === 'media') {
        window.open(item.mediaReportUrl, '_blank')
      } else {
        this.positionTopChange(window.pageYOffset)
        this.$router.push({
          name: `newsroom${this.capitalizeType}Detail`,
          params: {
            locale: this.$route.params.locale,
            newsroomId: item[`${this.type}Seq`]
          },
          query: { ...this.$route.query }
        })
      }
    },
    movePageNews (index) {
      if (this.keyword) {
        const base = { ...this.$route.query }
        base[this.type] = index
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: base
        })
      } else {
        this.movePage(index)
      }
    },
    more () {
      if (!this.moreActivation) {
        const index = this.pagination.current + 1

        this.$router.push({
          query: {
            ...this.$route.query,
            [this.pageQuery]: index,
            size: 'mobile'
          }
        })

        let options = {}
        if (this.keyword) {
          options = {
            ...options,
            searchKeyword: this.keyword,
            searchType: 'TITLE_CONTENT'
          }
        }
        const params = Object.assign({}, options, { pageNumber: index })
        this.loading = true
        this.getList(newsroomApi[`get${this.capitalizeType}`], params).then(() => {
          this.lists = [
            ...this.lists,
            ...this.desserts,
          ]
          this.loading = false
          this.$emit('loaded:newsroom', this.lists)
        })
      }
    },
    onImageError (e) {
      e.target.src = this.defaultImgPath
    }
  }
}
</script>
